import React from "react";
import Frame from "../../images/hero/floral_frame.svg";
import bg from "../../images/slider/hero-bg22.png";
import heroImage from "../../images/default/hero-2.png";
import { Fade, Slide } from "react-awesome-reveal";
import hero1 from "../../images/slider/shape2.svg";

import TimeCountDown from "../countdown";
import { connect } from "react-redux";
import {
  addDaysToDate,
  getCloudinaryFullPath,
  getEventDates,
  getDayDiffFromToday,
  parseAsLocalDate,
} from "../../utils";
import moment from "moment";
import TypeWriter from "../TypeWriter/TypeWriter";
import Calendar from "../Calendar/Calendar";
import { capitalize, getBrideGroomNameFromURL } from "../../utils/string";

const Hero4 = ({
  eventDate,
  bannerPhoto,
  isPreview = false,
  pathname = "",
  events = []
}) => {
  const { brideName, groomName } = getBrideGroomNameFromURL();

  const daysLeft = getDayDiffFromToday(eventDate);

  const countDownDate = isPreview
    ? addDaysToDate(16)
    : parseAsLocalDate(eventDate);

  const eventDates = getEventDates(events);

  return (
    <div className={"blissContainer static-hero-s2 wpo-static-hero-inner"}>
      {/* Hero Section */}
      <div className={"heroSection"}>
        <div class="image-container">
          <img
            className="zoom"
            src={getCloudinaryFullPath(`${bannerPhoto}`)}
            alt="Sample Image"
          />
          <div class="gradient-overlay"></div>
          <span></span>
        </div>
      </div>

      {/* Content */}
      <div className="contentSection">
        <div style={{ margin: "0 20px" }}>
          <Fade
            className="animate__animated animate__fadeInLeft"
            delay={400}
            duration={2000}
            triggerOnce="true"
          >
            <div>
              <h3 className="name">
                {capitalize(groomName)} & {capitalize(brideName)}
              </h3>
            </div>
          </Fade>
          <TypeWriter
            weddingDate={moment(countDownDate).format("MMMM DD, YYYY")}
            pathname={pathname}
          />
        </div>
        <div
          className="shape-2"
          style={{
            width: "130px",
            margin: "20px auto 10px",
          }}
        >
          <Slide cascade direction="up" duration={1000} triggerOnce="true">
            <img src={hero1} alt="" />
          </Slide>
        </div>
        {countDownDate && (
          <div
            className="wpo-wedding-date"
            style={{ marginTop: 10, marginBottom: 15 }}
          >
            <Slide direction="up" duration="1600" triggerOnce="true">
              <div className="clock-grids">
                <div id="clock">
                  <TimeCountDown weddingDate={countDownDate} />
                </div>
              </div>
            </Slide>
          </div>
        )}

        {/* Calendar Section */}
        <Slide cascade direction="left" duration={2000} triggerOnce="true">
          <div className={"calendarSection"}>
            <div className={"calendarWrapper"}>
              <Calendar eventDates={eventDates} />
            </div>
          </div>
        </Slide>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    eventDate: state.inviteDetails.invite?.eventDate,
    pathname: state.inviteDetails.invite?.pathname,
    bannerPhoto: state.inviteDetails.invite?.bannerPhoto,
    events: state.inviteDetails.invite?.events,
    isPreview: state.inviteDetails?.isPreview,
  };
};
export default connect(mapStateToProps)(Hero4);
